import { showNewMessage } from '@intercom/messenger-js-sdk'

/**
 * The public help center. Kept out of `constants/constants.js`, which is
 * already well past the 500-line limit in AGENTS.md.
 *
 * `/en/` rather than the bare host: help.finalbitai.com redirects the root to
 * the localized index, and brand's own `/help` route already treats that URL
 * as canonical. Linking straight to it skips a redirect hop.
 */
const HELP_CENTER_URL = 'https://help.finalbitai.com/en/'

// Until widget.intercom.io loads, the SDK parks a queueing stub (it carries
// `loaderQueue`) on window.Intercom. If an ad blocker stops that script the
// stub swallows every call, so it does not count as the messenger.
const isMessengerLoaded = () => {
  const intercom = window.Intercom
  return Boolean(process.env.REACT_APP_INTERCOM_ID) && typeof intercom === 'function' && !intercom.loaderQueue
}

/**
 * Opens a new Intercom conversation (the launcher is hidden, but the API still
 * opens the messenger). Falls back to the help center when the messenger is
 * unavailable; `noopener,noreferrer` because that is a third-party host.
 */
const openSupportChat = () => {
  if (isMessengerLoaded()) {
    showNewMessage()
    return
  }
  window.open(HELP_CENTER_URL, '_blank', 'noopener,noreferrer')
}

export { HELP_CENTER_URL, openSupportChat }
